<div class="modal-body _pop-overlay _price-trail-popup">
  <div class="mid-panel sub-expired">
    <div class="_pop-mid-content _reminder">
      <div class="_math-key-mid">
        <div class="_top-icon">
          <img src="assets/images/trail-icon.png" aria-hidden="true" />
        </div>
        <div class="heading">
          {{ headerText }}
        </div>
        <p>{{ 'loginSubscriptionPopupDescription.0' | translate }}&#64;{{ 'loginSubscriptionPopupDescription.1' | translate }}</p>
        <div class="_popup-btn">
          <a (click)="toSubscription()" class="button sub-btn">
            {{ 'loginSubscriptionPopupHeading' | translate }}
          </a>
          <a (click)="toUseCode()" class="button use-btn">
            {{ 'toolbarUserDropDownOptionFive' | translate }}
          </a>
          <a (click)="toCancel()" class="button secondary use-btn">
            {{ 'okay' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
